import { checkValueInArrayEnum } from 'src/utils/enum'
import {
  FulfillmentCenter,
  FulfillmentCenterType,
  FulfillmentCenterTypeFilters,
} from './types'

export const allFulfillmentCenterTypeFilters: Record<FulfillmentCenterType, boolean> = {
  [FulfillmentCenterType.FC]: true,
  [FulfillmentCenterType.MARKET_STORE]: true,
  [FulfillmentCenterType.DARK_STORE]: true,
}

export const defaultFulfillmentCenterTypeFilters: Record<FulfillmentCenterType, boolean> = {
  [FulfillmentCenterType.FC]: true,
  [FulfillmentCenterType.MARKET_STORE]: false,
  [FulfillmentCenterType.DARK_STORE]: true,
}

export const normalizeFulfillmentCenterTypeFilters = (
  filters?: FulfillmentCenterTypeFilters,
): Record<FulfillmentCenterType, boolean> => ({
  [FulfillmentCenterType.FC]: filters?.[FulfillmentCenterType.FC] ?? true,
  [FulfillmentCenterType.MARKET_STORE]: filters?.[FulfillmentCenterType.MARKET_STORE] ?? true,
  [FulfillmentCenterType.DARK_STORE]: filters?.[FulfillmentCenterType.DARK_STORE] ?? true,
})

export const areFulfillmentCenterTypeFiltersEqual = (
  firstFilters?: FulfillmentCenterTypeFilters,
  secondFilters?: FulfillmentCenterTypeFilters,
) => {
  const normalizedFirstFilters = normalizeFulfillmentCenterTypeFilters(firstFilters)
  const normalizedSecondFilters = normalizeFulfillmentCenterTypeFilters(secondFilters)

  return Object.values(FulfillmentCenterType).every((fulfillmentCenterType) => (
    normalizedFirstFilters[fulfillmentCenterType] === normalizedSecondFilters[fulfillmentCenterType]
  ))
}

const isFulfillmentCenterType = (
  fulfillmentCenterType: FulfillmentCenter['type'],
): fulfillmentCenterType is FulfillmentCenterType => (
  typeof fulfillmentCenterType === 'string'
  && checkValueInArrayEnum(fulfillmentCenterType, FulfillmentCenterType)
)

export const filterFulfillmentCentersByType = (
  fulfillmentCenters: FulfillmentCenter[],
  filters?: FulfillmentCenterTypeFilters,
) => {
  const normalizedFilters = normalizeFulfillmentCenterTypeFilters(filters)

  if (Object.values(normalizedFilters).every(Boolean)) {
    return fulfillmentCenters
  }

  return fulfillmentCenters.filter((fulfillmentCenter) => (
    isFulfillmentCenterType(fulfillmentCenter.type)
    && normalizedFilters[fulfillmentCenter.type] === true
  ))
}
